import React from "react";
import CustomPrintOutSalesOrder from "../../../../../partials/content/CustomPrintOutSalesOrder";
const SoPrintOut = ({ soData }) => {
  return (
    <React.Fragment>
      <CustomPrintOutSalesOrder salesOrderID={soData.ID} />
    </React.Fragment>
  );
};

export default SoPrintOut;
